module.exports = __webpack_public_path__ + "static/img/activity4.50462dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/aboutWe/activity4.jpg
// module id = 5/sN
// module chunks = 3